module.exports = __webpack_public_path__ + "img/icon_service_2023@2x.3132e522.png";